<template>
<div class="chapter">
<div class="inner_page">
<h3 class="h3"><a id="page_23"></a><a id="sec6"></a><span class="small">FROM</span> <em>Elegy</em></h3>
<h4 class="h4"><a id="sec7"></a>Landscape with the Fall of Icarus</h4>
<p class="poem">How could I have failed you like this?<br/>The narrator asks</p>
<p class="poem">The object. The object is a box<br/>Of ashes. How could I not have saved you,</p>
<p class="poem">A boy made of bone and blood. A boy<br/>Made of a mind. Of years. A hand</p>
<p class="poem">And paint on canvas. A marble carving.<br/>How can I not reach where you are</p>
<p class="poem">And pull you back. How can I be<br/>And you not. You’re forever on the platform</p>
<p class="poem">Seeing the pattern of the train door closing.<br/>Then the silver streak of me leaving.</p>
<p class="poem">What train was it? The number 6.<br/>What day was it? Wednesday.</p>
<p class="poem">We had both admired the miniature mosaics<br/>Stuck on the wall of the Met.</p>
<p class="poem">That car should be forever sealed in amber.<br/>That dolorous day should be forever</p>
<p class="poem">Embedded in amber.<br/>In garnet. In amber. In opal. In order</p>
<p class="poem">To keep going on. And how can it be<br/>That this means nothing to anyone but me now.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter1_c.vue?31918bb0